export default __webpack_public_path__ + "static/media/SIC-Logo.e68aed40.svg";